export enum ProductType {
    SIMPLE = 'simple',
    CUSTOMISE = 'customise',
    GROUPED = 'grouped',
    COMBO = 'combo'
}